import script from "./ScrollMixin.vue?vue&type=script&lang=js"
export * from "./ScrollMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__